
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 20h-14c-.827 0-1.5-.673-1.5-1.5v-13C1 4.673 1.673 4 2.5 4h14c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5zM2.5 5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-14zM16.5 3h-14a.5.5 0 0 1 0-1h14a.5.5 0 0 1 0 1zM15.5 1h-12a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1z"}}),_c('path',{attrs:{"d":"M11.5 13c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"}}),_c('path',{attrs:{"d":"M14.5 8h-10a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zM5 13.675l1.266-1.582c.073-.091.164-.142.259-.144s.189.044.266.131L9.387 15H5v-1.325zM14 15h-3.275l-3.187-3.585c-.272-.306-.651-.476-1.039-.466s-.758.199-1.014.519L5 12.074V8.999h9v6z"}})])
          )
        }
      }
    